import DataTable from './dataTable'
// import {storage} from '@/services/storage'

/******************************************************************************
 *  Proposals
 *****************************************************************************/

/**
 * @type {Proposal}
 */
export default class Proposal extends DataTable {

    constructor () {
        /** Verifica se as requisições do datatable serão feitas para a API V1 ou API V2 */
        // const funnelMongo = JSON.parse(storage.get('funnel_mongo'))
        // const httpId = (funnelMongo && funnelMongo.active && funnelMongo.active == 1) ? 'http2' : 'http'
        super('/funnel/deal', '/deals/proposal', 'http2')
        this.funnel_stage_id = 0

        this.columns = [
            this.prototypes.column('customer_name', 'customers.name', true, true),
            this.prototypes.column('customer_cpf', 'customers.cpf', true, false),
            this.prototypes.column('user_name', 'users.user_name', false, true),
            this.prototypes.column('stage_id', 'stg.id', false, true),
            this.prototypes.column('customer_origin', '', false, true),
            this.prototypes.column('product_id', 'p.id', false, false, { value: '', regex: true }),
            this.prototypes.column('product_name', 'p.product_name', false, false, { value: '', regex: true }),
            this.prototypes.column('cost', 'deal.cost', false, true),
            this.prototypes.column('customer_phone', 'customers.phone', true, false),
            this.prototypes.column('customer_mobile', 'customers.mobile', true, false),
            this.prototypes.column('customer_email', 'customers.email', true, false),
            this.prototypes.column('updated_at', 'deal.updated_at', false, true),
            this.prototypes.column('saled_at', 'deal.saled_at', false, true),
            this.prototypes.column('12', '', false, false),
            this.prototypes.column('created_at', 'deal.created_at', false, true),
            this.prototypes.column('stage', 'deal.funnel_stage', false, false),
            this.prototypes.column('id', 'deal.id', true, false),
            this.prototypes.column('team_id', 't.id', false, false),
            this.prototypes.column('manager_id', 'mfo.id', false, false),
            this.prototypes.column('broker_id', 'bfo.id', false, false),
            this.prototypes.column('customer_email', 'customers.email', true, false),
            this.prototypes.column('funnel_stage_status_id', 'deal.funnel_stage_status_id', false, false),
            this.prototypes.column('customer_mobile', 'customers.mobile', true, false),
            this.prototypes.column('customer_phone', 'customers.phone', true, false),
            this.prototypes.column('tags', 'tags.tag', false, true),
            this.prototypes.column('owner', 'filter_owner', false, true),
            this.prototypes.column('origin_id', 'deal.origin_id', false, false),
            this.prototypes.column('channel_id', 'channel_id', true, true),
        ]
    }

    /**
     * Sobreescrita do método básico REST que busca as instâncias de modo
     * a utilizar o novo endpoint com classes service e repository
     * 
     * @param {String} url
     * @param {Object} params 
     */
    getAll (url, params, config = {}) {
        return this.http.get(
            this.constructor.normalize('/funnel/deal/new', url),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getData(url, params) {
        return this.getAll(url, params)
            .then((response) => {
                if (response.data.total) {
                    this.funnel_stage_id = response.data.data[0].funnel_stage_id
                } else {
                    this.funnel_stage_id = 1
                }

                return response
            })
    }

    async readFilters() {
        const vm = this
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (vm.funnel_stage_id !== 0) {
                    clearInterval(interval)
                    return vm.http.get('/funnel/status', {
                            params: {
                                funnel_stage_id: vm.funnel_stage_id
                            }
                        })
                        .then((response) => {
                            const data = response.data.map((item) => {
                                item.text = item.name
                                return item
                            })
                            response.data = data

                            return resolve(response)
                        });
                }
            }, 200)
        })
    }

    async getProposalGroup() {
        return this.http.get('/funnel/deal/group/proposal')
    }

    async getProposalSettings(){
        return this.http.get('configuration/proposalSettings')
    }
}
